import React from 'react'

import { IMessageProps } from './interfaces'

import { Container, Icon, Content } from './styles'

const Message = (props: IMessageProps) => {
  return (
    <Container kind={props.kind} {...props}>
      {props.icon && <Icon name={props.icon} />}

      <Content>{props.children}</Content>
    </Container>
  )
}

Message.defaultProps = {
  kind: 'info',
}

export default Message
